import { create, all } from 'mathjs'

export default function calculateFormula(formula, variables) {
  try {
    const math = create(all)
    math.import({
      if: (condition, trueResult, falseResult) => (condition ? trueResult : falseResult),
    }, { override: true })

    const scope = Array.isArray(variables)
      ? Object.fromEntries(variables.map(v => [v.key, v.value]))
      : variables

    const builtInFunctions = Object.keys(math.expression.mathWithTransform)
    const allowedFunctions = ['if', 'iif']
    const formulaWithoutStrings = formula.replace(/'[^']*'|"[^"]*"/g, '')

    // імена функцій - ідентифікатори перед відкриваючою дужкою
    const formulaFunctions = Array.from(new Set(formulaWithoutStrings.match(/[A-Za-z_]+(?=\s*\()/g)))
    const undefinedFunctions = formulaFunctions.filter(f => !allowedFunctions.includes(f))

    if (undefinedFunctions.length > 0) {
      const highlightedFormula = formula.replace(new RegExp(`\\b(${undefinedFunctions.join('|')})\\b`, 'g'), '<b style="color: var(--color-error);">$1</b>')
      return { result: null, error: { key: 'undefinedFunctions', props: undefinedFunctions }, highlightedFormula }
    }

    // видаляємо виклики дозволених функцій, щоб їхні імена не вважались змінними
    const formulaWithoutFunctions = formulaWithoutStrings.replace(/[A-Za-z_]+\s*\(/g, '(')
    const formulaVariables = Array.from(new Set(formulaWithoutFunctions.match(/[A-Za-z_]+/g)))
    const usedVariables = Object.keys(scope)
    const undefinedVariables = formulaVariables.filter(v => !usedVariables.includes(v) && !builtInFunctions.includes(v))

    if (undefinedVariables.length > 0) {
      const highlightedFormula = formula.replace(new RegExp(`\\b(${undefinedVariables.join('|')})\\b`, 'g'), '<b style="color: var(--color-error);">$1</b>')
      return { result: null, error: { key: 'undefinedVariables', props: undefinedVariables }, highlightedFormula }
    }

    if (formula?.charAt(formula.length - 1)?.match(/[-+/*,./*(]/)) {
      const highlightedFormula = formula.replace(/[-+/*,./*(]$/, '<b style="color: var(--color-error);">$&</b>')
      return { result: null, error: { key: 'errorLastSymbol' }, highlightedFormula }
    }
    let result = math.evaluate(formula, scope)
    let highlightedFormula = formula
    let error = null

    if (result === Infinity) {
      highlightedFormula = formula.replace(/\/0/g, '<b style="color: var(--color-error);">/0</b>')
      result = null
      error = { key: 'divisionByZero' }
      return { result, error, highlightedFormula }
    } else if (isNaN(result)) {
      highlightedFormula = formula.replace(/NaN/g, '<b style="color: var(--color-error);">NaN</b>')
      result = null
      error = { key: 'invalidValue' }
      return { result, error, highlightedFormula }
    }

    return { result, error, highlightedFormula }
  } catch (error) {
    if (error.message.includes('Unexpected end of expression')) {
      //this.formulaError = this.errors['Unexpected end of expression'] || 'Неизвестная ошибка'
      const charIndex = formula.length - 1
      const highlightedFormula = `${formula.slice(0, charIndex)}<b style="color: var(--color-error);">${formula[charIndex]}</b>${formula.slice(charIndex + 1)}`
      return { result: null, error: { key: 'Unexpected end of expression' }, highlightedFormula }
    }

    if (error.message.includes('Syntax error in part')) {
      //this.formulaError = this.errors['Syntax error in part']
      const match = error.message.match(/in part "(.+?)"/)
      if (match) {
        const errorPart = match[1]
        const highlightedFormula = formula.replace(errorPart, `<b style="color: var(--color-error);">${errorPart}</b>`)
        return { result: null, error: { key: 'Syntax error in part' }, highlightedFormula }
      }
    }

    const match = error.message.match(/char (\d+)/)
    if (match) {
      let charIndex = parseInt(match[1], 10) - 1
      charIndex = charIndex === formula.length ? charIndex - 1 : charIndex

      error.message = error.message.replace(/\s*\(char \d+\)$/, '')
      const highlightedFormula = `${formula.slice(0, charIndex)}<b style="color: var(--color-error);">${formula[charIndex]}</b>${formula.slice(charIndex + 1)}`
      return { result: null, error: { key: error.message }, highlightedFormula }
    }
    return { result: null, error: { key: 'unknownError' }, highlightedFormula: formula }
  }
}
